import { createContext, useContext } from 'react'

export const ColorContext = createContext({})

export const useColorContext = () => useContext(ColorContext)
